import React from "react"
import { NavLink } from "react-router-dom"
import { useSelector } from "react-redux"
import { paths } from "../../routes/paths"
import styles from "./index.module.scss"
import { ADMIN } from "../../helpers/userRoles"

const AccountSidebarNav = () => {
  const userInfo = useSelector((state) => state.user)

  return (
    <div className={styles.navWrap}>
      <div className={styles.navList}>
        <NavLink
          to={paths.accountSettings}
          className={styles.navLink}
          activeClassName={styles.navLinkActive}
          exact
        >
          Settings
        </NavLink>
      </div>
      {userInfo.role !== ADMIN && (
        <div className={styles.navList}>
          <NavLink
            to={paths.accountSubscription}
            className={styles.navLink}
            activeClassName={styles.navLinkActive}
          >
            Subscription
          </NavLink>
        </div>
      )}
      <div className={styles.navList}>
        <NavLink
          to={paths.notificationsSettings}
          className={styles.navLink}
          activeClassName={styles.navLinkActive}
          exact
        >
          Notifications
        </NavLink>
      </div>
    </div>
  )
}

export default AccountSidebarNav
